// src/hooks/usePwaInstall.js

import { useState, useEffect } from 'react';

// Ten hook zawiera całą logikę PWA i zwraca stan oraz funkcje do użycia w dowolnym komponencie
export const usePwaInstall = () => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isIos, setIsIos] = useState(false);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    // Logika dla przeglądarek wspierających PWA (Android, Desktop)
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Logika wykrywania iOS
    const detectIos = () => /iPhone|iPad|iPod/.test(navigator.userAgent);
    if (detectIos() && !window.navigator.standalone) {
      setIsIos(true);
      setIsInstallable(true); // Na iOS też chcemy pokazać opcję instalacji
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (isIos) {
      alert("Aby zainstalować aplikację na iPhonie:\n1. Kliknij ikonę Udostępnij (kwadrat ze strzałką).\n2. Przewiń w dół i wybierz 'Dodaj do ekranu początkowego'.");
      return;
    }

    if (!installPrompt) {
      return;
    }
    await installPrompt.prompt();
    
    setInstallPrompt(null);
    setIsInstallable(false);
  };

  // Zwracamy wszystko, czego komponent może potrzebować
  return { isInstallable, isIos, handleInstallClick };
};